<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue'
import { useViewStore } from '@/stores/view'
import SearchFilters from "./SearchFilters"
import SearchFilterSavedFiltersMenu from "./SearchFilterSavedFiltersMenu"
import SearchFilterSaveFiltersForm from "./SearchFilterSaveFiltersForm"
import Button from '@/common/Button.vue'

const props = defineProps({
    viewId: String,
    offCanvasId: String
})

// Dynamic View Store
const viewStore = useViewStore(props.viewId)

// Template refs
const offcanvas = ref(null)

// Local operational states and handlers
let backdropEl = null
let onBackdropClick = null
let onShow = null
let onHide = null

onMounted(() => {
    const offcanvasEl = offcanvas.value
    if (!offcanvasEl) return

    // Create the customizable backdrop element safely matching your template structure
    backdropEl = document.createElement('div')
    backdropEl.classList.add('offcanvas-backdrop', 'fade', 'show', 'd-none')

    onBackdropClick = () => {
        offcanvasEl.querySelector('[data-bs-dismiss="offcanvas"]')?.click()
    }
    onShow = () => {
        backdropEl?.classList.remove('d-none')
    }
    onHide = () => {
        backdropEl?.classList.add('d-none')
    }

    backdropEl.addEventListener('click', onBackdropClick)
    offcanvasEl.after(backdropEl)

    offcanvasEl.addEventListener('show.bs.offcanvas', onShow)
    offcanvasEl.addEventListener('hide.bs.offcanvas', onHide)
})

onBeforeUnmount(() => {
    // Clean up global listeners and generated elements to completely eliminate memory leak vectors
    const offcanvasEl = offcanvas.value
    if (offcanvasEl) {
        if (onShow) offcanvasEl.removeEventListener('show.bs.offcanvas', onShow)
        if (onHide) offcanvasEl.removeEventListener('hide.bs.offcanvas', onHide)
    }

    if (backdropEl) {
        if (onBackdropClick) backdropEl.removeEventListener('click', onBackdropClick)
        backdropEl.remove()
        backdropEl = null
    }
})

// Methods
const addFilter = () => {
    if (props.viewId) {
        viewStore.addFilter()
    }
}
</script>

<template>
    <div ref="offcanvas" class="offcanvas offcanvas-start w-50" data-bs-scroll="true" data-bs-backdrop="false"
         tabindex="-1" :id="offCanvasId" :aria-labelledby="offCanvasId + 'Label'">
        <div class="offcanvas-header">
            <h5 class="offcanvas-title" :id="offCanvasId + 'Label'">Filters</h5>
            <button type="button" class="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>

        <div class="offcanvas-body">
            <SearchFilterSavedFiltersMenu :view-id="viewId"/>

            <SearchFilters :view-id="viewId"/>

            <div class="pt-3 d-flex align-items-center">
                <div class="flex-fill">
                    <Button @click="addFilter" class="btn-sm border focus-ring">
                        <i class="bi bi-plus-lg"/> filter
                    </Button>
                </div>
                <SearchFilterSaveFiltersForm :view-id="viewId"/>
            </div>
        </div>
    </div>
</template>